import React, { useContext } from "react";
import { RegistrationFormContext } from "./types";
import { InputRadio } from "../../../../HtmlComponents/InputRadio";

const Section6 = () => {
  const {
    practiceInPrivateMedicine,
    setPracticeInPrivateMedicine,
    privatePracticeAuthorization,
    setPrivatePracticeAuthorization,
  } = useContext(RegistrationFormContext);

  return (
    <>
      <div>
        <p className="font-bold text-main">
          {"28) "}exercez-vous la medecine privée dans:{" "}
        </p>
        <InputRadio
          checked={
            practiceInPrivateMedicine === "Cabinet personnel isolement" && true
          }
          labelName="Cabinet personnel isolément"
          id="CabinetPersonnelIsolement"
          value={"Cabinet personnel isolement"}
          setValue={setPracticeInPrivateMedicine}
        />
        <InputRadio
          checked={
            practiceInPrivateMedicine ===
              "Cabinet de groupe Uni disciplinaire" && true
          }
          labelName="Cabinet de groupe Uni disciplinaire"
          id="CabinetGroupeUniDisciplinaire"
          value={"Cabinet de groupe Uni disciplinaire"}
          setValue={setPracticeInPrivateMedicine}
        />
        <InputRadio
          checked={
            practiceInPrivateMedicine ===
              "Cabinet de groupe Multidisciplinaire" && true
          }
          labelName="Cabinet de groupe Multidisciplinaire"
          id="CabinetGroupeMultidisciplinaire"
          value={"Cabinet de groupe Multidisciplinaire"}
          setValue={setPracticeInPrivateMedicine}
        />
        <InputRadio
          checked={practiceInPrivateMedicine === "Cabinet privée" && true}
          labelName="Cabinet privée"
          id="CabinetPrivée"
          value={"Cabinet privée"}
          setValue={setPracticeInPrivateMedicine}
        />
        <InputRadio
          checked={
            practiceInPrivateMedicine === "Plusieurs cliniques privées" && true
          }
          labelName="Plusieurs cliniques privées"
          id="PlusieursCabinetsPrivées"
          value={"Plusieurs cliniques privées"}
          setValue={setPracticeInPrivateMedicine}
        />
        <InputRadio
          checked={
            practiceInPrivateMedicine === "Laboratoire d'analyses" && true
          }
          labelName="Laboratoire d'analyses"
          id="LaboratoireAnalyses"
          value={"Laboratoire d'analyses"}
          setValue={setPracticeInPrivateMedicine}
        />
      </div>
      <div>
        <p className="font-bold text-main">
          {"29) "}Possedez-vous une autorisation d'exercice a titre privé:{" "}
        </p>
        <InputRadio
          checked={
            privatePracticeAuthorization ===
              "En dehors du lieu et des horaires de travail" && true
          }
          labelName="En dehors du lieu et des horaires de travail"
          id="EnDehorsDuLieuEtDesHorairesDeTravail"
          value={"En dehors du lieu et des horaires de travail"}
          setValue={setPrivatePracticeAuthorization}
        />
        <InputRadio
          checked={
            privatePracticeAuthorization ===
              "Ouverture d'un etablissement médical privé" && true
          }
          labelName="Ouverture d'un etablissement médical privé"
          id="OuvertureUnEtablissementMédicalPrivé"
          value={"Ouverture d'un etablissement médical privé"}
          setValue={setPrivatePracticeAuthorization}
        />
      </div>
    </>
  );
};

export default Section6;
